export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";
export const USER_FETCH_CACHED = "USER_FETCH_CACHED";
export const UPDATE_BUDDIES = "UPDATE_BUDDIES";
export const UPDATE_MODAL_PREFERENCES = "UPDATE_MODAL_PREFERENCES";
export const UPDATE_ANALYTICS = "UPDATE_ANALYTICS";
